module.exports = __webpack_public_path__ + "files/2c27e95cd07f10616c92ba2af3156b0b.svg";